import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "", as = "div" }) => {
    const Comp = motion[as] || motion.div;
    return (
        <Comp
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay, ease: EASE }}
        >
            {children}
        </Comp>
    );
};

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            className="block will-change-transform"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const Counter = ({ value, suffix = "", className = "" }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-60px" });
    const [display, setDisplay] = useState("0");
    const numeric = parseFloat(value);

    useEffect(() => {
        if (!inView || Number.isNaN(numeric)) return undefined;
        const controls = animate(0, numeric, {
            duration: 1.6,
            ease: EASE,
            onUpdate: (v) => setDisplay(Number.isInteger(numeric) ? Math.round(v).toString() : v.toFixed(1)),
        });
        return () => controls.stop();
    }, [inView, numeric]);

    return (
        <span ref={ref} className={className}>
            {Number.isNaN(numeric) ? value : display}
            {suffix}
        </span>
    );
};
